export const REQUEST_PRESCRIPTION_RENEWAL = 'REQUEST_PRESCRIPTION_RENEWAL'
export const RECEIVE_PRESCRIPTION_RENEWAL = 'RECEIVE_PRESCRIPTION_RENEWAL'
export const REQUEST_SAVE_PRESCRIPTION_RENEWAL = 'REQUEST_SAVE_PRESCRIPTION_RENEWAL'
export const RECEIVE_SAVE_PRESCRIPTION_RENEWAL = 'RECEIVE_SAVE_PRESCRIPTION_RENEWAL'
export const RESET_PRESCRIPTION_RENEWAL = 'RESET_PRESCRIPTION_RENEWAL'

export const REQUEST_PRESCRIPTION_RENEWAL_PRICES_DEADLINES = 'REQUEST_PRESCRIPTION_RENEWAL_PRICES_DEADLINES'
export const RECEIVE_PRESCRIPTION_RENEWAL_PRICES_DEADLINES = 'RECEIVE_PRESCRIPTION_RENEWAL_PRICES_DEADLINES'
